export const initialState = {
    loader: false,
    product: [],
    error: ''
}